// extracted by mini-css-extract-plugin
export default {"menuItem":"MenuItem-menuItem-XlMdU","isDisabled":"MenuItem-isDisabled-iQzs8"};